export default function RefreshIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.3 21v-4.4c0-.746.604-1.35 1.349-1.35h4.4a.75.75 0 010 1.5H4.113a9.243 9.243 0 007.936 4.5c4.796 0 8.74-3.65 9.204-8.324a.75.75 0 011.494.148l-.063.506c-.765 5.188-5.234 9.17-10.635 9.17a10.743 10.743 0 01-9.25-5.273V21a.75.75 0 01-1.5 0zM12 1.25c3.938 0 7.378 2.118 9.25 5.274V3a.75.75 0 011.5 0v4.4a1.35 1.35 0 01-1.35 1.35H17a.75.75 0 010-1.5h2.937A9.244 9.244 0 0012 2.75a9.252 9.252 0 00-9.205 8.324.75.75 0 01-1.492-.148c.54-5.433 5.123-9.676 10.698-9.676z"
        fill={props.fill}
      />
    </svg>
  )
}

